import { FirebaseApp } from "./firebase-app";
import { signOut, onAuthStateChanged, signInWithPopup } from "firebase/auth";

export class AuthAPI {
  static async googleSignIn() {
    try {
      const result = await signInWithPopup(FirebaseApp.auth, FirebaseApp.googleProvider);
      if (result && result.user) {
        const user = result.user.providerData[0];
        delete user.uid;
        delete user.providerId;
        delete user.phoneNumber;
        return {
          userRecord: user,
        };
      } else {
        return null;
      }
    } catch (err) {
      alert(err);
    }
  }

  static validateCurrentUser = async () => {
    try {
      let userValidatePromise = new Promise((resolve, reject) => {
        const unsubscribe = onAuthStateChanged(
          FirebaseApp.auth,
          (user) => {
            unsubscribe();
            resolve(user);
          },
          reject // pass up any errors attaching the listener
        );
      });

      let userValidateResult = await userValidatePromise;
      userValidateResult && (await userValidateResult.getIdToken());

      return userValidateResult;
    } catch (err) {
      alert(err);
    }
  };

  static logOut = async () => {
    try {
      await signOut(FirebaseApp.auth);
    } catch (err) {
      alert(err);
    }
  };
}
